import {
    Component,
    AfterViewInit,
    OnDestroy,
    Renderer2,
    OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { WindowScrollController } from "@fullcalendar/core";
import { TranslateService } from "@ngx-translate/core";
import { PrimeNGConfig } from "primeng/api";
import { BehaviorSubject, Subscription } from "rxjs";
import { AppComponent } from "./app.component";
import { LanguageIds } from "./argic/enums/language-ids";
import { LoginService } from "./login/login.service";
import { ChangeRequestChatService } from "./argic/services/change-request-chat.service";

declare var loadpartialview:any;

@Component({
    selector: "app-main",
    templateUrl: "./app.main.component.html",
})
export class AppMainComponent implements AfterViewInit, OnDestroy, OnInit {
    activeTabIndex = -1;
    sidebarActive = false;
    topbarMenuActive: boolean;
    overlayMenuActive: boolean;
    staticMenuDesktopInactive: boolean;
    staticMenuMobileActive: boolean;
    rotateMenuButton: boolean;
    topbarItemClick: boolean;
    menuButtonClick: boolean;
    activeTopbarItem: any;
    documentClickListener: () => void;
    configActive: boolean;
    configClick: boolean;
    sidebarClick: boolean;
    subs: Subscription[]=[];

    siteSearchQuery= new BehaviorSubject<string>(null);

    hasChangeRequestAccess: boolean = false;
    isChangeRequestAdmin: boolean = false;

    constructor(
        public renderer: Renderer2,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        public router: Router,
        public loginService: LoginService,
        public translate: TranslateService,
        private changeRequestService: ChangeRequestChatService
    ) {}



    private checkChangeRequestAccess(): void {
        this.changeRequestService.hasDiscussionAccess().subscribe({
            next: (response) => {
                this.hasChangeRequestAccess = response.hasAccess;
                this.isChangeRequestAdmin = response.isAdmin;
            },
            error: () => {
                this.hasChangeRequestAccess = false;
                this.isChangeRequestAdmin = false;
            }
        });
    }

    ngOnInit() {
        
        this.primengConfig.ripple = true;
        this.subs.push( this.loginService.user$.subscribe(u=>{if(u!=null){
            this.checkChangeRequestAccess();
            this.switchLangWithCode(u.languageId)}
        }))

        this.subs.push( this.siteSearchQuery.subscribe(x=>
            {
                //go to matrix search with filled in eurocode
                if(x?.trim().length){
                    this.router.navigate(['/']).then(() => {
                        this.router.navigateByUrl("/matrixsearch",{state:{sitesearch:x}});

                    })
                }

                //doorgeven van vars via de navigateByUrl
            }

        ));
    }

    ngAfterViewInit() {
        this.documentClickListener = this.renderer.listen(
            "body",
            "click",
            (event) => {
                if (!this.topbarItemClick) {
                    this.activeTopbarItem = null;
                    this.topbarMenuActive = false;
                }

                if (
                    !this.menuButtonClick &&
                    !this.sidebarClick &&
                    (this.overlay || !this.isDesktop())
                ) {
                    this.sidebarActive = false;
                }

                if (this.configActive && !this.configClick) {
                    this.configActive = false;
                }

                this.configClick = false;
                this.topbarItemClick = false;
                this.sidebarClick = false;
                this.menuButtonClick = false;
            }
        );
    }

    onTabClick(event: Event, index: number) {
        if (this.activeTabIndex === index) {
            this.sidebarActive = !this.sidebarActive;
        } else {
            this.activeTabIndex = index;
            this.sidebarActive = true;
        }

        event.preventDefault();
    }

    goToSearchTool() {
        this.activeTabIndex = 1;
        this.sidebarActive = false;
        this.router.navigateByUrl("/matrixsearch");
    }


    goToAdminDashboard() {
        this.sidebarActive = false;
        this.router.navigateByUrl("/admin-dashboard");
    }

    goToDashboard() {
        this.activeTabIndex = 0;
        this.sidebarActive = false;
        this.router.navigateByUrl("/home");
    }

    goToDatadownload() {
        this.router.navigateByUrl("/download/data");
    }

    goToInfodownload() {
        this.router.navigateByUrl("/download/info");
    }

    goToWizard() {
        this.router.navigateByUrl("/wizard");
    }

    goToTC(){
        this.router.navigateByUrl("/technicalcommittee");

    }

    goToChangeRequestDiscussion() {
        this.activeTabIndex = 2;
        this.sidebarActive = false;
        this.router.navigateByUrl("/change-request-discussion");
    }
    
    goToMyChangeRequests() {
        this.activeTabIndex = 2;
        this.sidebarActive = false;
        this.router.navigateByUrl("/my-change-requests");
    }

    goToGeneralinfo() {
        this.activeTabIndex = 3;
        this.sidebarActive = false;
        this.router.navigateByUrl("/generalinfo");
    }

    closeSidebar(event: Event) {
        this.sidebarActive = false;
        event.preventDefault();
    }

    onSidebarClick(event: Event) {
        this.sidebarClick = true;
    }

    onTopbarMenuButtonClick(event: Event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        event.preventDefault();
    }

    onMenuButtonClick(event: Event, index: number) {
        this.menuButtonClick = true;
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        this.sidebarActive = !this.sidebarActive;

        if (this.app.layoutMode === "overlay") {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive =
                    !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }

        if (this.activeTabIndex < 0) {
            this.activeTabIndex = 0;
        }

        event.preventDefault();
    }

    onTopbarItemClick(event: Event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSearchItemClick(event: Event) {
        this.topbarItemClick = true;

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onLogout(event) {
        //this.loginService.logout();
        window.location.href="/Account/Logout";
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    get overlay(): boolean {
        return this.app.layoutMode === "overlay";
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    switchLang(lang: string) {
        this.translate
        this.translate.use(lang);
    }
    switchLangWithCode(id:number){
        if(id === LanguageIds.EN) this.switchLang('en');
        if(id === LanguageIds.DE) this.switchLang('de');
        if(id === LanguageIds.FR) this.switchLang('fr');
        if(id === LanguageIds.IT) this.switchLang('it');
        if(id === LanguageIds.ES) this.switchLang('es');
        if(id === LanguageIds.NL) this.switchLang('nl');
        if(id === LanguageIds.TR) this.switchLang('tr');
        if(id === LanguageIds.PY) this.switchLang('py');
        if(id === LanguageIds.PT) this.switchLang('pt');
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
        this.subs.forEach(s=>s.unsubscribe());
    }

    goToSettings() {
        event.preventDefault();
        this.router.navigateByUrl("/settings");
    }

    // goToPartialView(str:string) {
    //     //alert('integration in development - not available yet');
    //     loadpartialview(str);
    //     event.preventDefault();
    // }

}
